// src/utils/color-utils.js
export const clamp = (n, min, max) => Math.min(Math.max(n, min), max);

export const normalizeHex = (hex) => {
  let h = hex.replace('#', '').trim();
  if (h.length === 3) h = h.split('').map(c => c + c).join('');
  if (h.length === 4) h = h.slice(0, 3).split('').map(c => c + c).join('');
  if (h.length === 6) return h.toUpperCase();
  if (h.length === 8) return h.slice(0, 6).toUpperCase();
  throw new Error('Unsupported hex format');
};

export const toHex2 = (n) => n.toString(16).padStart(2, '0').toUpperCase();

export const hexWithAlpha = (hex, alpha01) => {
  const clean = normalizeHex(hex);
  const a = toHex2(Math.round(clamp(alpha01, 0, 1) * 255));
  return `#${clean}${a}`;
};

export const hexToRgb = (hex) => {
  const h = normalizeHex(hex);
  return {
    r: parseInt(h.slice(0, 2), 16),
    g: parseInt(h.slice(2, 4), 16),
    b: parseInt(h.slice(4, 6), 16),
  };
};
